export default "__VITE_ASSET__0e408cc2__"